import "core-js/modules/es.number.constructor.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "SvgIcon",
  props: {
    iconContent: {
      type: String,
      default: ""
    },
    iconAlt: {
      type: String,
      default: ""
    },
    iconStyle: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 25
    },
    height: {
      type: Number,
      default: 25
    }
  }
});